import { Box, Button, Collapse, HStack, Text } from '@chakra-ui/react';
import { useMyProfile } from 'lib/hooks';
import { set } from 'lodash';
import { useQueryClient } from 'react-query';
import { successToast } from 'lib/toasts';
import Panel from '@inspire/ui/general/Panel';

const DONE_STATUS = 'done';
const PENDING_STATUS = 'not_yet';

const ProjetOrientationItem = ({ etapes, item }) => {
  const queryClient = useQueryClient();
  const { setAndRefetchMyProfile } = useMyProfile(null, {
    onMutate: async ({ input }) => {
      await queryClient.cancelQueries(['MyProfile', null]);
      queryClient.setQueryData(['MyProfile', null], (old: any) => {
        return set(
          old,
          'myUser.profile.prochainesEtapes',
          input.prochainesEtapes
        );
      });
    },
  });
  const answer = etapes.find((e) => e.name === item.name);
  const status = answer?.status;
  const setStatus = (newStatus) => {
    const prochainesEtapes = etapes
      .filter((e) => e.name !== item.name)
      .concat({
        name: item.name,
        status: newStatus,
      });
    setAndRefetchMyProfile({
      prochainesEtapes,
    });
  };

  return (
    <Box
      as={Panel}
      mb={5}
      p={5}
      border="1px solid #ccc"
      borderRadius={4}
      bg={status === DONE_STATUS ? '#efefef' : 'white'}
      textAlign="left"
    >
      <Text fontSize="sm" color="grey" m={0}>
        Je connais déjà...?
      </Text>
      <Text>
        <strong>{item.title}</strong>{' '}
      </Text>

      <Collapse in={status === DONE_STATUS} animateOpacity>
        <Button
          onClick={() => {
            setStatus(PENDING_STATUS);
          }}
          fontSize="sm"
          whiteSpace="nowrap"
          variant="link"
          color="black"
        >
          [+ d'infos]
        </Button>
      </Collapse>

      <Collapse in={status === PENDING_STATUS} animateOpacity>
        <item.todoText />
      </Collapse>

      {status !== DONE_STATUS && (
        <HStack spacing={4}>
          <Button
            size="sm"
            // maxW="140px"
            isActive={status === DONE_STATUS}
            onClick={() => {
              setStatus(DONE_STATUS);
              successToast(
                'Bravo ! Ton projet d’orientation est déjà bien abouti ! Pour aller plus loin, n’hésite pas à consulter les articles de notre blog, le kit de survie de la vie étudiante et à contacter des étudiants éclaireurs.'
              );
            }}
            flexGrow={[1, null, 0]}
          >
            Je connais !
          </Button>
          {status !== PENDING_STATUS && (
            <Button
              size="sm"
              onClick={() => setStatus(PENDING_STATUS)}
              isActive={status === PENDING_STATUS}
              flexGrow={[1, null, 0]}
            >
              Pas encore
            </Button>
          )}
        </HStack>
      )}
    </Box>
  );
};

export default ProjetOrientationItem;
